import { t } from 'i18next';
import {
    IconAvatar,
    IconCustomAccess,
    IconDepartment,
    InfoChip,
} from '../../../../../components/buttons/IconButtons';
import CustomUserChip from '../../../../../components/CustomUserChip';
import CustomGenericTittleIconDataChip from './../../../../../components/CustomGenericTittleIconDataChip';
import NotInformation from '../../../../../components/NotInformation';
import CustomMediumChip from '../../../../../components/CustomMediumChip';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const MenuListDetails = ({ row }) => {

    return (
        <>
            <CustomGenericTittleIconDataChip Icon={IconCustomAccess} title='meal_times' />
            <div className='mb-4 d-flex flex-wrap gap-2 mt-3'>
                {row.foodieMealTimeStocks.map((element, index) => (
                    <CustomMediumChip key={element.mealTimeId} title={element.mealTimeName}>
                        <div className='mt-2 d-flex w-100 align-items-center align-content-center justify-content-between'>
                            {element.stock && <span>{`${element.stock || ''} ${t('units').toLocaleLowerCase()}`}</span>}
                        </div>
                    </CustomMediumChip>
                ))}
            </div>
            <CustomUserChip
                className={'mt-0 chip-secondary-100 mb-2'}
                name={t('department_release')}
                Icon={InfoChip}
                showAvatar={true}
                classNameIcon={'icon-color-secondary-700'}
            />
            <div className='d-flex flex-column gap-2 pb-3 mt-2'>
                {row?.departments?.length > 0 ? (
                    row.departments.map((element) => (
                        <div
                            key={element.departmentId}
                            className='d-flex align-items-center justify-content-start border-top-shades-300 gap-3 '
                        >
                            <p className='mb-0 '>
                                {element.availableAfterMinutes} {t('min_later')}
                            </p>
                            <div className='mb-2'>
                                <CustomUserChip
                                    name={element?.departmentName}
                                    Icon={IconDepartment}
                                    showAvatar={true}
                                    classNameIcon={"icon-color-shades-400"}
                                />
                            </div>
                        </div>
                    ))
                ) : (
                    <div className='mt-0'>
                        <NotInformation card={true} text={t('no_information_departments')} />
                    </div>
                )}
            </div>
            <CustomGenericTittleIconDataChip Icon={IconCustomAccess} title='custom_access' />
            {row?.users?.length > 0 ? (
                <div className='d-flex flex-wrap gap-2'>
                    <>
                        {row.users?.map((element, index) => (
                            <CustomUserChip
                                key={`user-${index}`}
                                name={element.name}
                                Icon={IconAvatar}
                                showAvatar={true}
                            />
                        ))}
                    </>
                </div>
            ) : (
                <div className='mt-3'>
                    <NotInformation card={true} text={t('no_information_custom_access')} />
                </div>
            )}
        </>
    );
};

export default MenuListDetails;
